/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';


export interface ValidateRequestParams {
    force?: boolean;
}

export class ClsValidateRequestParams {
    force?: boolean = undefined;
}

export interface ValidateTenantRequestParams {
    tenantId: string;
    force?: boolean;
}

export class ClsValidateTenantRequestParams {
    tenantId: string = undefined;
    force?: boolean = undefined;
}


export interface AdminEricValidationApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Trigger eric validation for all entities
     * 
* @param requestParameters
     */
    validate(requestParameters: ValidateRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Trigger eric validation for given Tenant
     * 
* @param requestParameters
     */
    validateTenant(requestParameters: ValidateTenantRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
